var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"disabled":_vm.isStart}},[_c('span',[_vm._v(_vm._s(_vm.isStart ? _vm.timed + "S" : _vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }